module.exports = __webpack_public_path__ + "static/media/foodbev_headerlogo.0b88792e.png";